import api from "../apis/AiOnboardApi";

const extractList = (res) => {
  const body = res?.data;
  const nested = body?.data;
  const list = Array.isArray(body)
    ? body
    : Array.isArray(nested)
    ? nested
    : nested?.result ?? nested?.data ?? body?.result ?? [];
  return Array.isArray(list) ? list : [];
};

export const ListAiOnboardedLearners =
  (onSuccess, onError) => (dispatch) => {
    api
      .AiOnboardApi()
      .list()
      .then((res) => {
        onSuccess?.(extractList(res));
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to fetch AI onboarded learners";
        onError?.(msg);
      });
  };

export const UpdateAiOnboardedLearner =
  (id, data, onSuccess, onError) => (dispatch) => {
    api
      .AiOnboardApi()
      .update(id, data)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to update AI onboarded learner";
        onError?.(msg);
      });
  };
